import { ComponentRef, Injectable, ViewContainerRef } from '@angular/core';
import { PleaseWaitCircleComponent } from '../../components/please-wait-circle/please-wait-circle.component';

@Injectable({
  providedIn: 'root',
})
export class PageLoadingService {
  private _viewContainerRef: ViewContainerRef;
  private loadingComponentRef: ComponentRef<PleaseWaitCircleComponent>;

  set viewContainerRef(viewContainerRef: ViewContainerRef) {
    this._viewContainerRef = viewContainerRef;
  }

  show(): void {
    if (!this.loadingComponentRef) {
      this.loadingComponentRef = this._viewContainerRef?.createComponent(PleaseWaitCircleComponent);
    }
  }

  hide(): void {
    if (this.loadingComponentRef) {
      this.loadingComponentRef.destroy();
      this.loadingComponentRef = null;
    }
  }
}
